import { render, staticRenderFns } from "./Pointing.vue?vue&type=template&id=5e2af7c4&"
import script from "./Pointing.vue?vue&type=script&lang=ts&"
export * from "./Pointing.vue?vue&type=script&lang=ts&"
import style0 from "./Pointing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports